import React, { useState, useEffect, Component } from "react";
import RoundSlider from "./RoundSlider";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Button from "@mui/material/Button";
import sliderrImage from "../../../assets/images/sliderImage.png";
import { useSelector } from "react-redux";
import "./index.css";

const RoundedThumbSlider = () => {
  const [count, setCount] = useState(16);
  const [counttwo, setCounttwo] = useState(22);
  const handlePlus = () => {
    setCount(count + 1);
    if (count === 20) {
      setCount(20);
    }
  };
  const handleMinus = () => {
    setCount(count - 1);
    if (count === 12) {
      setCount(12);
    }
  };
  const handlePlusTwo = () => {
    setCounttwo(counttwo + 1);
    if (counttwo === 28) {
      setCounttwo(28);
    }
  };
  const handleMinusTwo = () => {
    setCounttwo(counttwo - 1);

    if (counttwo === 20) {
      setCounttwo(20);
    }
  };
  const mobileQuery = useSelector((state) => state?.OnioSlicer?.iphonePotrait);

  return (
    <Box sx={{ position: "relative", mb: 3, mt: 3 }}>
      <Box className="slider-container" sx={{ ml: 10 }}>
        <RoundSlider
          sliderType="range"
          handleShape="dot"
          update={"24"}
          value={`${count} ,${counttwo}`}
          startAngle="270"
          endAngle="90"
          radius="200"
          width="9"
          handleSize="+14"
          min="12"
          max="28"
          step="1"
          direction={0}
        />
        <img src={sliderrImage} alt="" className="slider-Image" />
        <Typography className="threetwo">32°C</Typography>
        <Typography className="sixteen">16°C</Typography>
      </Box>

      <div className="room-temp">
        <Typography className="lilText">ROOM TEMPRETURE</Typography>
        <Typography className="typo-sizes">{count + 4}°C</Typography>
      </div>
      {/* bottom counter */}
      <div className="botomPosition">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Box className="bottom-boxes-flex">
            <Box>
              <Typography
                sx={{ color: "#909090", fontSize: "14px", textAlign: "center" }}
              >
                MIN TEMP
              </Typography>
              <Box sx={{ display: "flex" }}>
                <Button
                  onClick={handlePlus}
                  sx={{ color: "white" }}
                  size="medium"
                >
                  <AddIcon fontSize="large" />
                </Button>
                <Typography className="typo-two">{count + 4}°C</Typography>
                <Button onClick={handleMinus} size="medium">
                  <RemoveIcon sx={{ color: "white" }} fontSize="large" />
                </Button>
              </Box>
            </Box>
            <Box>
              <Typography
                sx={{ color: "#909090", fontSize: "14px", textAlign: "center" }}
              >
                MAX TEMP
              </Typography>
              <Box sx={{ display: "flex" }}>
                <Button
                  sx={{ color: "white" }}
                  onClick={handlePlusTwo}
                  size="medium"
                >
                  <AddIcon fontSize="large" />
                </Button>
                <Typography className="typo-two">{counttwo + 4}°C</Typography>
                <Button onClick={handleMinusTwo} size="large">
                  <RemoveIcon sx={{ color: "white" }} fontSize="medium" />
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </div>
    </Box>
  );
};

export default RoundedThumbSlider;
